import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft, ArrowRight, Calendar, Clock } from "lucide-react";
import Seo from "../components/Seo";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { getArticle, ARTICLE_SIGNATURE, ARTICLES } from "../content/journal";
import { SITE_URL } from "../seo/routes-meta";
import { breadcrumbLd } from "../seo/jsonld";

function Block({ b }) {
  if (b.h2) return <h2 className="article-h2">{b.h2}</h2>;
  if (b.ul) return <ul className="article-ul">{b.ul.map((li, i) => <li key={i} dangerouslySetInnerHTML={{ __html: li }} />)}</ul>;
  if (b.cta) return <div className="article-cta"><Link to={b.cta.to} className="btn btn--primary" data-testid="article-cta">{b.cta.label} <ArrowRight size={16} /></Link></div>;
  if (b.p) return <p className="article-p" dangerouslySetInnerHTML={{ __html: b.p }} />;
  return null;
}

export default function Article() {
  const { slug } = useParams();
  const article = getArticle(slug);
  if (!article) return <Navigate to="/journal" replace />;

  const others = ARTICLES.filter((a) => a.slug !== slug).slice(0, 2);
  const url = SITE_URL + "/journal/" + article.slug;
  const articleLd = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: article.title,
    description: article.description,
    datePublished: article.date,
    dateModified: article.date,
    mainEntityOfPage: url,
    url,
    image: SITE_URL + "/img/og-image.jpg",
    author: { "@type": "Organization", name: "VIRALYA" },
    publisher: { "@type": "Organization", name: "VIRALYA", logo: { "@type": "ImageObject", url: SITE_URL + "/icon-512.png" } },
  };

  return (
    <div>
      <Seo
        path={`/journal/${article.slug}`}
        title={`${article.title} | VIRALYA`}
        description={article.description}
        jsonLd={[articleLd, breadcrumbLd([{ name: "Accueil", path: "/" }, { name: "Journal", path: "/journal" }, { name: article.tag, path: `/journal/${article.slug}` }])]}
      />
      <Header />
      <main className="page">
        <div className="container page-narrow">
          <Link to="/journal" className="back-link"><ArrowLeft size={15} /> Journal</Link>
          <span className="journal-tag" style={{ marginBottom: "0.9rem", display: "inline-block" }}>{article.tag}</span>
          <h1 className="h2 article-title" data-testid="article-title">{article.title}</h1>
          <div className="journal-meta" style={{ margin: "1rem 0 2rem" }}>
            <span><Calendar size={13} /> {article.dateLabel}</span>
            <span><Clock size={13} /> {article.read}</span>
          </div>

          <article className="article-body" data-testid="article-body">
            {article.body.map((b, i) => <Block b={b} key={i} />)}
            <p className="article-signature">{ARTICLE_SIGNATURE}</p>
          </article>

          {others.length > 0 && (
            <div className="article-next">
              <h3 className="h3" style={{ marginBottom: "1rem" }}>À lire aussi</h3>
              <div className="journal-list">
                {others.map((a) => (
                  <Link to={`/journal/${a.slug}`} key={a.slug} className="glass card journal-card" data-testid={`article-next-${a.slug}`}>
                    <span className="journal-tag">{a.tag}</span>
                    <h2 className="journal-card__title">{a.title}</h2>
                    <div className="journal-meta"><span className="journal-more">Lire <ArrowRight size={14} /></span></div>
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
